import 'normalize.css';
import Vue from 'vue'
import App from './App.vue'
import Vuelidate from "vuelidate";
import vueScrollto from 'vue-scrollto'
import router from './router'
import { AccordionPlugin } from '@syncfusion/ej2-vue-navigations';
import firebase from 'firebase'
import 'firebase/firestore'
import firebaseConfig from './firebaseConfig.js';

import VueAnalytics from 'vue-analytics'

// In main.js
import VueScrollReveal from 'vue-scroll-reveal';

// // Using ScrollReveal's default configuration
// Vue.use(VueScrollReveal);
 
// OR specifying custom default options for all uses of the directive
Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal', // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
  distance: '50px',
  reset: false,
});

Vue.use(VueAnalytics, {
  id: 'UA-88380922-8',
  router
})

Vue.use(AccordionPlugin);

Vue.use(Vuelidate);
Vue.config.productionTip = false;

Vue.use(vueScrollto)



import VueFacebookPixel from 'vue-analytics-facebook-pixel'
Vue.use(VueFacebookPixel)

Vue.analytics.fbq.init('351793112431871', {
  em: 'mart.denheijer@gmail.com'
})



Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app');